import z from "zod";

export const formSchema = z.object({
  property: z.string().min(10, "Minimum of 10 characters.").max(12, "Maximum of 12 characters."),
});
